import React from "react"
import SectionHeader from "../../SectionHeader/SectionHeader"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import ServiceIcon from "../../../images/format_list_bulleted-24px.svg"
import Button from "../../Button/Button"
import { paramCase } from "param-case"
import useFacilityData from "../../../hooks/useFacilityData.ts"

const HomeServiceLinksSyles = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const HomeServiceLinksList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 145px;
  a,
  button {
    margin-right: 0;
    .Button-content {
      justify-content: flex-start;
    }
  }
  @media screen and (min-width: 790px) {
    flex-direction: row;
    a,
    button {
      margin-right: 35px;
      margin-bottom: 25px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`

const HomeServiceLinks = () => {
  const pageData = useFacilityData()

  const serviceArr = pageData.sanityFacility.facilityObj.services

  const serviceList = serviceArr.map(service => {
    return (
      <Button
        key={service._key}
        element={AnchorLink}
        to={`/${paramCase(service.title)}`}
        icon={<ServiceIcon />}
      >
        {service.title}
      </Button>
    )
  })

  return (
    <HomeServiceLinksSyles id="HomePage-serviceLinks" role="region">
      <SectionHeader>Services</SectionHeader>
      <HomeServiceLinksList>{serviceList}</HomeServiceLinksList>
    </HomeServiceLinksSyles>
  )
}

export default HomeServiceLinks
